import FadeUp from "./FadeUp";
import { Check, X } from "lucide-react";

const perfect = [
    "Productivity apps (planners, note takers, calendars, AI writing tools, focus and workflow apps)",
    "Founder-led team",
    "Wants an in-house creator engine",
];

const notFor = [
    "One-off influencer campaigns",
    "Celebrity or mega-influencer plays",
    "Two-week quick wins",
];

export const IdealClient = () => (
    <section
        id="ideal-client"
        data-testid="ideal-client-section"
        className="py-24 md:py-32 bg-[#FAFAFA] border-y border-black/[0.06]"
    >
        <div className="container-page">
            <div className="max-w-3xl">
                <FadeUp>
                    <p className="text-xs font-bold tracking-[0.22em] uppercase text-gray-500">
                        Ideal client
                    </p>
                </FadeUp>
                <FadeUp delay={0.05}>
                    <h2
                        data-testid="ideal-client-heading"
                        className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.3] text-[#0A0A0A] text-balance"
                    >
                        Honest about the fit.
                    </h2>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <p className="mt-5 text-[15.5px] md:text-base text-gray-600 leading-relaxed max-w-2xl">
                        This works when it fits. When it doesn't, I'll say so on the call.
                    </p>
                </FadeUp>
            </div>

            <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
                <FadeUp delay={0.05}>
                    <div
                        data-testid="ideal-perfect"
                        className="h-full rounded-2xl bg-white border border-black/[0.08] p-7 md:p-8"
                    >
                        <div className="inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white px-3 py-1 text-[11px] font-bold tracking-[0.15em] uppercase">
                            Perfect for
                        </div>
                        <ul className="mt-6 space-y-3.5">
                            {perfect.map((p, i) => (
                                <li
                                    key={i}
                                    data-testid={`ideal-perfect-${i}`}
                                    className="flex items-start gap-3 text-[15px] text-[#0A0A0A] leading-[1.65]"
                                >
                                    <span className="mt-0.5 flex-none h-5 w-5 rounded-full bg-[#C6F432] flex items-center justify-center">
                                        <Check className="h-3 w-3 text-[#0A0A0A]" strokeWidth={3} />
                                    </span>
                                    {p}
                                </li>
                            ))}
                        </ul>
                    </div>
                </FadeUp>

                <FadeUp delay={0.1}>
                    <div
                        data-testid="ideal-not-for"
                        className="h-full rounded-2xl bg-white border border-black/[0.08] p-7 md:p-8"
                    >
                        <div className="inline-flex items-center gap-2 rounded-full bg-white border border-black/[0.08] text-gray-600 px-3 py-1 text-[11px] font-bold tracking-[0.15em] uppercase">
                            Not for
                        </div>
                        <ul className="mt-6 space-y-3.5">
                            {notFor.map((p, i) => (
                                <li
                                    key={i}
                                    data-testid={`ideal-notfor-${i}`}
                                    className="flex items-start gap-3 text-[15px] text-gray-500 leading-[1.65]"
                                >
                                    <span className="mt-0.5 flex-none h-5 w-5 rounded-full bg-[#FAFAFA] border border-black/[0.08] flex items-center justify-center">
                                        <X className="h-3 w-3 text-gray-400" strokeWidth={3} />
                                    </span>
                                    {p}
                                </li>
                            ))}
                        </ul>
                    </div>
                </FadeUp>
            </div>
        </div>
    </section>
);

export default IdealClient;
